(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diwali-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('diwali-countdown-bar')) return;

    const DAY = 86400000;
    const MIN = 60000;

    /** "+05:30" → offset in ms, or null */
    const parseOffset = (tz) => {
      const m = /^([+-])(\d{2}):(\d{2})$/.exec(tz);
      return m ? (m[1] === '-' ? -1 : 1) * (m[2] * 60 + +m[3]) * MIN : null;
    };

    /** "21:30" → ms after local midnight, or null */
    const parseTime = (time) => {
      const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(time);
      return m ? (m[1] * 60 + +m[2]) * MIN : null;
    };

    /** "2026-11-08" → epoch ms of local midnight in that offset, or null (rejects e.g. 2026-02-31) */
    const parseDay = (date, offset) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
      const t = Date.parse(`${date}T00:00:00Z`);
      if (Number.isNaN(t) || new Date(t).toISOString().slice(0, 10) !== date) return null;
      return t - offset;
    };

    /** Validates the section settings and returns the schedule config + any errors. */
    const buildConfig = ({ reset: resetRaw, tz, start: startRaw, end: endRaw }) => {
      const errors = [];
      const offset = parseOffset(tz) ?? 0;
      let reset = parseTime(resetRaw);
      if (reset === null) {
        errors.push(`Daily reset time "${resetRaw}" is invalid — use HH:MM (24h). Using 00:00.`);
        reset = 0;
      }

      const day = (raw, label) => {
        if (!raw) return null;
        const t = parseDay(raw, offset);
        if (t === null) errors.push(`${label} "${raw}" is invalid — use YYYY-MM-DD.`);
        return t;
      };

      const start = day(startRaw, 'Start date');
      const endDay = day(endRaw, 'End date');
      // The offer ends at the first daily reset after the end date begins (00:00 reset = end of that day).
      const end = endDay === null ? null : endDay + (reset || DAY);

      if (start !== null && end !== null && end <= start) {
        errors.push('End date must be on or after the start date.');
      }

      return { offset, reset, start, end, errors };
    };

    /** Pure scheduling logic: where are we in today's 24h cycle, and is the offer on? */
    const schedule = (now, { offset, reset, start, end }) => {
      const elapsed = (((now + offset - reset) % DAY) + DAY) % DAY;
      const cycleEnd = now - elapsed + DAY;
      const status =
        start !== null && now < start ? 'upcoming' : end !== null && now >= end ? 'ended' : 'live';
      return { status, cycleEnd };
    };

    class DiwaliCountdownBar extends HTMLElement {
      connectedCallback() {
        const { sectionId, sticky, editor } = this.dataset;

        this.editor = editor === 'true';
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.storageKey = `diwali-bar:${sectionId}`;
        this.cfg = buildConfig(this.dataset);
        this.digits = [...this.querySelectorAll('.diwali-bar__digit')];
        this.notice = this.querySelector('[data-notice]');
        this.abort = new AbortController();

        this.section = this.closest('.shopify-section');
        this.section?.classList.toggle('diwali-bar-sticky-section', sticky === 'true');

        if (this.cfg.errors.length) console.warn('[Diwali bar]', ...this.cfg.errors);

        if (!this.editor && this.isDismissed()) {
          this.hidden = true;
          return;
        }

        this.querySelector('[data-close]')?.addEventListener('click', () => this.dismiss(), {
          signal: this.abort.signal,
        });

        this.tick();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.section?.classList.remove('diwali-bar-sticky-section');
      }

      tick = () => {
        const now = Date.now();
        const { status, cycleEnd } = schedule(now, this.cfg);
        this.cycleEnd = cycleEnd;

        if (this.editor) this.setNotice(status);
        else this.hidden = status !== 'live';

        // -1ms so the display runs 23:59:59 → 00:00:00, then restarts at 23:59:59.
        this.paint(Math.floor((cycleEnd - now - 1) / 1000));

        if (status === 'ended' && !this.editor) return; // campaign over: stop for good

        // Re-align to the next whole second so ticks never drift.
        this.timer = setTimeout(this.tick, 1000 - (Date.now() % 1000) + 20);
      };

      paint(total) {
        const value = [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60]
          .map((n) => String(n).padStart(2, '0'))
          .join('');
        const animate = this.painted && !this.reduceMotion && !document.hidden;

        this.digits.forEach((el, i) => {
          if (el.textContent === value[i]) return;
          if (animate) this.flip(el, value[i]);
          else el.textContent = value[i];
        });

        this.painted = true;
      }

      flip(el, value) {
        el.getAnimations().forEach((a) => a.cancel());
        el.animate(
          [{ transform: 'rotateX(0)', opacity: 1 }, { transform: 'rotateX(-90deg)', opacity: 0 }],
          { duration: 180, easing: 'cubic-bezier(0.55, 0.06, 0.68, 0.19)', fill: 'forwards' }
        ).onfinish = () => {
          el.textContent = value;
          el.animate(
            [{ transform: 'rotateX(90deg)', opacity: 0 }, { transform: 'rotateX(0)', opacity: 1 }],
            { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
          );
        };
      }

      setNotice(status) {
        if (!this.notice) return;
        const text =
          this.cfg.errors.join(' ') ||
          {
            upcoming: 'Preview — offer is scheduled and will appear on the start date.',
            ended: 'Preview — offer has ended and is hidden on the live store.',
          }[status] ||
          '';
        if (this.notice.textContent !== text) this.notice.textContent = text;
        this.notice.hidden = !text;
      }

      /** Dismissal lasts until the next daily reset — the offer comes back tomorrow. */
      isDismissed() {
        try {
          return Number(localStorage.getItem(this.storageKey)) > Date.now();
        } catch {
          return false;
        }
      }

      dismiss() {
        try {
          localStorage.setItem(this.storageKey, String(this.cycleEnd));
        } catch {}
        clearTimeout(this.timer);

        if (this.reduceMotion) {
          this.hidden = true;
          return;
        }

        this.animate(
          { transform: ['translateY(0)', 'translateY(-100%)'], opacity: [1, 0] },
          { duration: 380, easing: 'cubic-bezier(0.55, 0.06, 0.68, 0.19)', fill: 'forwards' }
        ).onfinish = () => {
          this.hidden = true;
        };
      }
    }

    customElements.define('diwali-countdown-bar', DiwaliCountdownBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-board"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var duration = 420;

  function prefersReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bind(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';
    root.classList.add('faq-board--ready');

    root.querySelectorAll('.faq-board__item').forEach(function (item) {
      var summary = item.querySelector('summary');
      var panel = item.querySelector('.faq-board__a');
      var inner = item.querySelector('.faq-board__a-inner');
      if (!summary || !panel || !inner) return;

      item._faqGen = 0;
      if (item.open) item.classList.add('is-open');
      else panel.style.height = '0px';

      function settle(gen, fn) {
        function onEnd(e) {
          if (e.target !== panel || e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          if (gen !== item._faqGen) return;
          fn();
        }
        panel.addEventListener('transitionend', onEnd);
      }

      function collapse() {
        item._faqGen += 1;
        var gen = item._faqGen;
        item.classList.remove('is-open');
        if (prefersReduced()) {
          item.open = false;
          panel.style.transition = '';
          panel.style.height = '0px';
          return;
        }
        panel.style.transition = 'none';
        var start = panel.getBoundingClientRect().height;
        if (start < 1) {
          item.open = false;
          panel.style.height = '0px';
          return;
        }
        panel.style.height = start + 'px';
        panel.offsetHeight;
        panel.style.transition = 'height ' + duration + 'ms ' + ease;
        panel.style.height = '0px';
        settle(gen, function () {
          item.open = false;
          panel.style.transition = '';
          panel.style.height = '0px';
        });
      }

      function expand() {
        item._faqGen += 1;
        var gen = item._faqGen;
        item.open = true;
        item.classList.add('is-open');
        if (prefersReduced()) {
          panel.style.transition = '';
          panel.style.height = 'auto';
          return;
        }
        panel.style.transition = 'none';
        var start = panel.getBoundingClientRect().height;
        panel.style.height = 'auto';
        var end = panel.offsetHeight;
        panel.style.height = start + 'px';
        panel.offsetHeight;
        panel.style.transition = 'height ' + duration + 'ms ' + ease;
        panel.style.height = end + 'px';
        settle(gen, function () {
          if (!item.classList.contains('is-open')) return;
          panel.style.transition = '';
          panel.style.height = 'auto';
        });
      }

      item._faqCollapse = collapse;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (item.classList.contains('is-open')) {
          collapse();
          return;
        }
        root.querySelectorAll('.faq-board__item.is-open').forEach(function (other) {
          if (other !== item && other._faqCollapse) other._faqCollapse();
        });
        expand();
      });
    });
  }

  function boot(scope) {
    var root = scope || document;
    if (root.matches && root.matches('.faq-board')) bind(root);
    root.querySelectorAll('.faq-board').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patent-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('patent-carousel')) {
    customElements.define('patent-carousel', class PatentCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dlg = this.querySelector('[data-modal]');
        if (!this.track) return;
        this.slides = [...this.track.querySelectorAll('[data-slide]')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.dotsEl = this.querySelector('[data-dots]');
        this.countEl = this.querySelector('[data-count]');
        try { this.cards = JSON.parse(this.querySelector('[data-cards]').textContent); } catch (e) { this.cards = []; }

        this.dots = [];
        if (this.dotsEl) {
          this.dots = this.slides.map(() => {
            const d = document.createElement('span');
            d.className = 'pt__dot-i';
            this.dotsEl.append(d);
            return d;
          });
        }
        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.sync(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        });
        this.sync();

        this.track.addEventListener('click', (e) => {
          const b = e.target.closest('[data-open]');
          if (b) this.open(Number(b.dataset.open));
        });
        if (this.dlg) {
          this.dlg.querySelector('[data-close]').addEventListener('click', () => this.dlg.close());
          this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.dlg.close(); });
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      step(dir) {
        const s = this.slides[0];
        if (!s) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: dir * (s.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      sync() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        // Everything fits (wide screens): no controls needed.
        if (max <= 2) this.setAttribute('data-static', ''); else this.removeAttribute('data-static');
        if (this.prev) this.prev.disabled = t.scrollLeft <= 4;
        if (this.next) this.next.disabled = t.scrollLeft >= max - 4;
        const n = this.slides.length;
        const i = max > 0 ? Math.round((t.scrollLeft / max) * (n - 1)) : 0;
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (this.countEl) this.countEl.textContent = (i + 1) + ' / ' + n;
      }

      open(i) {
        const card = this.cards[i];
        if (!this.dlg || !card) return;
        this.dlg.querySelector('[data-m-title]').textContent = card.title || '';
        this.dlg.querySelector('[data-m-kind]').textContent = card.kind || '';
        const body = this.dlg.querySelector('[data-m-body]');
        body.replaceChildren();
        (card.images || []).forEach((m) => {
          const img = document.createElement('img');
          img.src = m.src;
          img.alt = m.alt || '';
          if (m.w && m.h) { img.width = m.w; img.height = m.h; }
          img.decoding = 'async';
          body.append(img);
        });
        body.scrollTop = 0;
        if (!this.dlg.open) {
          try { this.dlg.showModal(); } catch (e) { this.dlg.setAttribute('open', ''); }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
